import { render } from "./domestic-standard.vue?vue&type=template&id=bbc6d482&scoped=true"
import script from "./domestic-standard.vue?vue&type=script&lang=js"
export * from "./domestic-standard.vue?vue&type=script&lang=js"

import "./domestic-standard.vue?vue&type=style&index=0&id=bbc6d482&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbc6d482"]])

export default __exports__